import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostListener,
  inject,
} from '@angular/core';
import { DynamicPageBaseComponent } from '@ups/xplat/dynamic-render';
import { MessageHelper } from '@ups/xplat/web/core';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'ups-dynamic-page',
  templateUrl: 'dynamic-page.component.html',
  // WI 35909 (S3): the shared base (also NativeScript, so it cannot mark) builds the form asynchronously and ends
  // each build with formReady$; the success overlay flips from a save callback and a timer. Both mark here.
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DynamicPageComponent extends DynamicPageBaseComponent {
  msg = inject(MessageHelper);
  private readonly cdr = inject(ChangeDetectorRef);

  override get showFormSuccess() {
    return super.showFormSuccess;
  }
  override set showFormSuccess(value) {
    super.showFormSuccess = value;
    this.cdr.markForCheck();
  }

  // Browser stopping code from executing
  @HostListener('window:beforeunload', ['$event']) handleUnload(e) {
    if (this.draftReady) {
      e.preventDefault();
      e.returnValue = `You have unsaved changes, leave anyway?`;
    }
  }

  constructor() {
    super();
    this.draftResponseAlert$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.msg.success(
        'Your Draft has been saved and can be found on your My Submissions page'
      );
    });
    // dynamicGroup, showWhatsNew and the container metadata are all written before formReady$ fires
    this.dynamicRender.formReady$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.cdr.markForCheck());
  }
}
